export const UPDATE_DIALOG_CUSTOMER = 'UPDATE_DIALOG_CUSTOMER';
